import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { CardContainer } from "@msys/ui";
import { Phone as PhoneIcon } from "@mui/icons-material";
import { List } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { MxCallListItem } from "../../mx-calls/MxCallListItem.js";
import { useProjectOverviewMxCallsBoxQuery } from "./ProjectOverviewMxCallsBox.generated.js";

interface Props {
  projectId: string;
}

export const ProjectOverviewMxCallsBox = ({ projectId }: Props) => {
  const { t } = useTranslate(["ProjectOverview", "Global"]);
  const client = useApolloClient();

  const { data, loading } = useProjectOverviewMxCallsBoxQuery({
    client,
    variables: { projectId },
  });

  const mxCallsConnection = getDataOrNull(data?.mxCalls);
  const calls = mxCallsConnection?.edges.map(edge => edge.node) ?? [];

  return calls.length > 0 ? (
    <CardContainer
      Icon={<PhoneIcon />}
      title={t("Calls", { ns: "ProjectOverview" })}
      isExpandable
      isInitiallyClosed={false}
      itemCount={mxCallsConnection?.totalCount}
      isLoading={loading}
    >
      <List disablePadding>
        {calls.map(call => (
          <MxCallListItem key={call.id} call={call} />
        ))}
      </List>
    </CardContainer>
  ) : null;
};
